import React, { useEffect, useState } from 'react';
import './Plans.scss';
import { safeHtml, processHTML } from '../../../../services/helpers';
import { baseStrapiURL } from '../../../../services/config';

export default function Plans({ content }) {
    const [backgroundImage, setBackgroundImage] = useState('');

    useEffect(() => {
        setBackgroundImage(baseStrapiURL + content.Photo.url)
    }, [])

    useEffect(() => {
        const checkWebPSupport = () => {
            const img = new Image();
            img.onload = () => {
                if (img.height > 0 && img.width > 0) {
                    setBackgroundImage(baseStrapiURL + content.Photo.url);
                }
            };

        };
        checkWebPSupport();
    }, []);

    return (
        <div
            className='workshop-plans'
            style={{
                backgroundImage: `url(${backgroundImage})`
            }}
        >
            <div className='workshop-plans__opacityBkg'></div>
            <h2>{content.Titre}</h2>
            <ul className='workshop-plans__plans_list'>
                {
                    content.FormuleEtItems.map((plan, index) => (
                        <li
                            key={index}
                            className='workshop-plans__plan'
                        >
                            <h3>{plan.formule?.TitreAffiché}</h3>
                            <div className='workshop-plans__list_container'>
                                <div className="workshop-plans__list_descr" dangerouslySetInnerHTML={safeHtml(plan.formule?.Description)} />
                                {
                                    plan.Inclus?.length > 0 &&
                                    <>
                                        <div className='line'></div>
                                        <ul className='workshop-plans__items_list'>
                                            {
                                                plan.Inclus
                                                    ?.sort((a, b) => a.ordre - b.ordre)
                                                    .map((item, index) => (
                                                        <li
                                                            key={index}
                                                            className='workshop-plans__item'
                                                        >
                                                            {/* <SvgIcons
                                                                name={'confirm'}
                                                                width={100}
                                                                height={100}
                                                                color={'#8C6239'}
                                                                margin={'-10px 0 -10px 0'}
                                                            /> */}
                                                            {/* <div className="item_text" dangerouslySetInnerHTML={safeHtml(item.Texte)} /> */}
                                                            <div className="item_text">{processHTML(item.Texte)}</div>
                                                            {
                                                                item.AvecOuEnBas ?
                                                                    <p className='orText'>OU</p>
                                                                    : null
                                                            }
                                                        </li>
                                                    ))
                                            }
                                        </ul>
                                    </>
                                }
                                <div className='workshop-plans__list_container_opacityBkg'></div>
                            </div>
                            {/* {
                                plan.Exclus?.length > 0 &&
                                    <ul className='workshop-plans__items_list'>
                                        {
                                            plan.Exclus
                                                ?.sort((a, b) => a.ordre - b.ordre) 
                                                .map((item, index) => (
                                                <li 
                                                    key={index}
                                                    className='workshop-plans__item'
                                                >
                                                    <SvgIcons
                                                        name={'close'}
                                                        width={100}
                                                        height={100}
                                                        color={'#EE2332'}
                                                    />
                                                    <div className="item_text" dangerouslySetInnerHTML={safeHtml(item.Texte)} />
                                                </li>
                                            ))
                                        }
                                    </ul>
                            } */}
                            <p className='workshop-plans__strikethrough_price'>
                                {plan.formule?.TarifBarré}
                            </p>
                            <p className='workshop-plans__price'>
                                {plan.formule?.Tarif}
                            </p>
                            <p className='workshop-plans__note'>
                                {plan.formule?.Note}
                            </p>
                            {
                                (plan.formule?.Texte1Bouton || plan.formule?.Texte2Bouton) &&
                                    <a
                                        href={plan.formule?.LienBouton}
                                        className="workshop-plans__btn_link"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <span>{plan.formule?.Texte1Bouton}</span>
                                        <span>{plan.formule?.Texte2Bouton}</span>
                                    </a>
                            }
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}